<div class="card d-flex flex-row p-3 rounded-25 m-1" style="border-radius: 25px;width: 200px" (click)="navigateTo()">
  <div class="m-auto">
    <img alt="icon path" [src]="this.iconPath">
  </div>
  <span>&nbsp;</span>
  <div class="m-auto" translate>{{this.title}}</div>
</div>
